import { FC, useEffect, useState } from "react";
import { Modal, Spinner } from "react-bootstrap";
import {
  ClienteDetalhe,
  fetchClienteById,
} from "../utils/cardapio.api";

const PATH_URL = "https://companies-admin.aacceson.com/";

interface Props {
  show: boolean;
  clienteId: number | null;
  onClose: () => void;
}

function resolveImage(src: string | null | undefined): string {
  if (!src) return "/media/avatars/blank.png";
  if (src.startsWith("http") || src.startsWith("data:")) return src;
  return `${PATH_URL}${src}`;
}

/** Modal com dados do cliente (usuarios + pulseiras). */
export const ClienteDadosModal: FC<Props> = ({
  show,
  clienteId,
  onClose,
}) => {
  const [loading, setLoading] = useState(false);
  const [cliente, setCliente] = useState<ClienteDetalhe | null>(null);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!show || !clienteId) {
      setCliente(null);
      setError("");
      return;
    }
    setLoading(true);
    setError("");
    fetchClienteById(clienteId)
      .then((data) => {
        setCliente(data);
        if (!data) setError("Cliente não encontrado.");
      })
      .catch(() => {
        setCliente(null);
        setError("Não foi possível carregar os dados do cliente.");
      })
      .finally(() => setLoading(false));
  }, [show, clienteId]);

  const fullName = cliente
    ? `${cliente.nome || ""} ${cliente.sobrenome || ""}`.trim()
    : "";

  return (
    <Modal show={show} onHide={onClose} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Cadastro do Cliente</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading && (
          <div className="text-center py-10">
            <Spinner animation="border" />
          </div>
        )}
        {!loading && error && (
          <div className="alert alert-warning mb-0">{error}</div>
        )}
        {!loading && cliente && (
          <div className="row g-5 align-items-start">
            <div className="col-md-4 text-center">
              <img
                src={resolveImage(cliente.imagem_perfil)}
                alt={fullName || "Cliente"}
                style={{
                  width: 160,
                  height: 160,
                  borderRadius: "50%",
                  objectFit: "cover",
                  border: "3px solid #e4e6ef",
                }}
              />
            </div>
            <div className="col-md-8">
              <div className="mb-4">
                <div className="text-muted fs-7">Nome</div>
                <div className="fw-bold fs-4">{fullName || "—"}</div>
              </div>
              <div className="mb-4">
                <div className="text-muted fs-7">CPF</div>
                <div className="fw-semibold">{cliente.cpf || "—"}</div>
              </div>
              <div>
                <div className="text-muted fs-7 mb-2">Pulseira(s)</div>
                {cliente.pulseiras.length === 0 ? (
                  <div className="text-muted">Nenhuma pulseira vinculada</div>
                ) : (
                  <ul className="list-group">
                    {cliente.pulseiras.map((p, idx) => (
                      <li
                        key={`${p.conteudo || ""}-${p.mestre || ""}-${idx}`}
                        className="list-group-item d-flex justify-content-between"
                      >
                        <span>
                          <strong>Conteúdo:</strong> {p.conteudo || "—"}
                        </span>
                        <span>
                          <strong>Mestre:</strong> {p.mestre || "—"}
                        </span>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className="btn btn-light" onClick={onClose}>
          Fechar
        </button>
      </Modal.Footer>
    </Modal>
  );
};
